import upperFirst from "lodash-es/upperFirst";

import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";

import { RunHistoryEntryType } from "../../types";

type SkippedEntryProps = {
  note: string | null;
  timestamp: number;
};

const SkippedEntry = ({ note, timestamp }: SkippedEntryProps) => {
  return (
    <HistoryEntryWrapper state={RunHistoryEntryType.Skipped} timestamp={timestamp} terminal>
      {note && <HistoryEntryNote>{upperFirst(note)}</HistoryEntryNote>}
    </HistoryEntryWrapper>
  );
};

export default SkippedEntry;
